import * as React from 'react';
import "rxjs/add/observable/from";
import MarkerInfo from '../MarkerInfo';

import {
    Marker,
    InfoWindow
} from "react-google-maps";

export type MarkerIcon = {
    anchor: { x: number, y: number },
    path: string,

    fillColor?: string,
    fillOpacity?: number,
    rotation?: number,
    scale?: number,
    strokeWeight?: number
}

type Position = {
    lat: number,
    lng: number
}

type MapMarkerProps = {
    icon: MarkerIcon,
    id: number,
    interactive: boolean,
    isOpen: boolean,
    popup: JSX.Element,
    position: Position,
}

type MapMarkerActions = {
    toggleMarkerPopup: Function
}

type MapMarkerAllProps = MapMarkerProps & MapMarkerActions;

class MapMarker extends React.PureComponent<MapMarkerAllProps, any> {
    constructor(props, context) {
        super(props, context);
        this.onToggleOpen = this.onToggleOpen.bind(this);
    }

    onToggleOpen() {
        if (this.props.interactive) {
            this.props.toggleMarkerPopup(this.props.id);
        }
    }

    render() {
        return <Marker
            defaultOptions={{ maxWidth: "825px", maxHeight: "700px" }}
            icon={this.props.icon}
            position={this.props.position}
            onClick={this.onToggleOpen}
        >
            {this.props.isOpen ?
                this.props.popup :
                undefined}
        </Marker>
    }
}

export default MapMarker;
